import { inject, Injectable } from '@angular/core';
import { ApiClient } from './api-client';
import { Observable } from 'rxjs';
import { Endpoints } from './endpoints';
import { LookupType } from '../models/lookup/lookup-type';
import { SHARED_CONFIG } from '../../../environments/shared-config.token';
import { ODataResponse } from '../models/odata/odata-response';
import { Country } from '../models/address/country-type';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LookupTypeApi {
  private apiClient = inject(ApiClient);
  private config = inject(SHARED_CONFIG);

  getMemberStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getMemberStatusTypes()}`);
  }

  getZoneTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getZoneTypes()}`);
  }

  getJobCategoryTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getJobCategoryTypes()}`);
  }

  getLanguageTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getLanguageTypes()}`);
  }

  getGenderTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getGenderTypes()}`);
  }

  getMemberTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getMemberTypes()}`);
  }

  getMemberEmployerStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getMemberEmployerStatusTypes()}`);
  }

  getCountryTypes(canadaUSOnly: boolean): Observable<ODataResponse<Country>> {
    let params = new HttpParams();
    if (canadaUSOnly) {
      params = params.set('$filter', `countryCode eq 'US' OR countryCode eq 'CA'`);
    }
    params = params.set('$expand', 'states');
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getCountryTypes()}`, params);
  }

  getApplicationStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getApplicationStatusTypes()}`);
  }

  getApplicationTaskStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getApplicationTaskStatusTypes()}`);
  }

  getFacilityTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getFacilityTypes()}`);
  }

  getFacilityStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getFacilityStatusTypes()}`);
  }

  getGolfCourseTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getGolfCourseTypes()}`);
  }

  getRaceTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getRaceTypes()}`);
  }

  getEthnicityTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getEthnicityTypes()}`);
  }

  getPronounTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getPronounTypes()}`);
  }

  getLgbtStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getLgbtStatusTypes()}`);
  }

  getIndigenousStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getIndigenousStatusTypes()}`);
  }

  getIndigenousTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getIndigenousTypes()}`);
  }

  getDisabilityStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getDisabilityStatusTypes()}`);
  }

  getDisabilityTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getDisabilityTypes()}`);
  }

  getEventStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getEventStatusTypes()}`);
  }

  getEventTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getEventTypes()}`);
  }

  getMemberClassificationTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getMemberClassificationTypes()}`);
  }

  getEventRegistrationTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getEventRegistrationTypes()}`);
  }

  getEventRegistrationStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getEventRegistrationStatusTypes()}`);
  }

  getGlAccountTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getGlAccountTypes()}`);
  }
  getInvoiceStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getInvoiceStatusTypes()}`);
  }
  getInvoiceTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getInvoiceTypes()}`);
  }
  getEventRegistrantTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getEventRegistrantTypes()}`);
  }
  getAlertStatusTypes(): Observable<ODataResponse<LookupType>> {
    return this.apiClient.get(`${this.config.apiUrl}${Endpoints.LookupType.getAlertStatusTypes()}`);
  }
}
